export default __webpack_public_path__ + "static/media/ninjago.48956a22.png";